<template>
  <div class="login" style="100%">
    <div class="header">
      <span class="header-tit">农村集体三资监管工作平台</span>
    </div>
    <div class="content">
        <el-row :gutter="20" style="margin-left: 0;">
          <el-col :span="24">
            <div class="fr-box">
              <div class="fr-box-content" style="border-radius: 20px;">
                <div class="login-tit">
                  <p>请登录</p>
                  <i></i>
                </div>
                <div class="login-content">
                  <el-form :model="loginForm" ref="loginForm" :rules="rules">
                    <el-form-item prop="username">
                      <el-input
                        placeholder="请输入身份证号"
                        v-model="loginForm.username"
                      >
                      </el-input>
                    </el-form-item>
                    <el-button :plain="true" type="primary" @click="loginBtn">登录</el-button>
                  </el-form>
                  <!-- <el-form :model="loginForm" ref="loginForm" :rules="rules">
                    <el-form-item prop="username">
                      <el-input
                        placeholder="账号"
                        v-model="loginForm.username"
                      >
                      </el-input>
                    </el-form-item>
                    <el-form-item prop="pwwd">
                      <el-input type="password"
                        placeholder="密码"
                        v-model="loginForm.pwwd"
                      >
                      </el-input>
                    </el-form-item>
                    <el-button :plain="true" type="primary" @click="loginBtn">登录</el-button>
                  </el-form> -->
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { loginid, loginNameIdcard } from "@/api/loginid";
import { Toast } from "mint-ui";
import ElementUI from 'element-ui'; //element-ui的全部组件
Vue.use(ElementUI);
export default {
  beforeCreate() {
      document.getElementsByTagName("body")[0].style.margin = 0;
  },
  data() {
    return {
      loginForm: {
        account: "",
        pwwd: "",
        username: ''
      },
      rules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
      }
    };
  },
  methods: {
    loginBtn() {
      let _this = this;
      // loginNameIdcard(this.loginForm).then(res => {
      //   console.log(res,'-------------------')
      //   let data = res.data;
      //   let code = data.result.xzqh.orgcode;
      //   if(data.errcode == 0){
      //   this.$router.push({ 
      //     name: "xzqh",
      //     params: { code },
      //   });
      //   }else{
      //       Toast({
      //         position: 'bottom',
      //         message: data.msg
      //       })
      //   }
      // })
      //账号密码登录
      // if(this.loginForm.username == "loufanx" && this.loginForm.pwwd == "a123456!"){
      //   this.$router.push({path: "/xzqh"})
      // }else{
      //   Toast({
      //     position: 'bottom',
      //     message: '账号或密码错误'
      //   })
      // }
      // return;
      //身份证号验证
      loginid(_this.loginForm.username).then(res => {
        console.log(res.data.errcode);
        if(res.data.errcode == '-1'){
            Toast({
              position: 'bottom',
              message: res.data.errmsg
            })
        }
        let data = res.data;
        let code =  res.data.result.orgcode;
        if(!data.errcode){
          this.setCookie(
            'sign',
            data.result.sign,
            7
          );
          this.$router.push({ 
            name: "xzqh",
            params: { code },
          });
        }else{
          alert(data.errmsg)
        }
      });
    },
    setCookie(c_name, value, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
      window.document.cookie =
        "sign" + "=" + value + ";path=/;expires=" + exdate.toGMTString();
    },
  }
};
</script>



<style lang="scss" scoped>
.login {
  height: 100vh;
  width: 100%;
  .header {
    height: 120px;
    line-height: 120px;
    padding: 0 30px;
    text-align: center;
    span {
      line-height: 20px;
    }
    .header-tit {
      color: #3383d0;
      font-size: 20px;
      font-family: "黑体";
      font-weight: bold;
    }
    .header-login {
      float: right;
      color: #999999;
      font-size: 14px;
    }
  }
  .content {
    background: url("../../assets/images/login.png") no-repeat;
    background-size: 100%;
    width: 100%;
    height: calc(100% - 350px);
  }
  .footer {
    height: 120px;
    line-height: 120px;
    text-align: center;
    p {
      color: #999999;
      font-size: 14px;
      margin: 0;
    }
  }
  .el-row,
  .fl-box,
  .fr-box {
    height: 100%;
    width: 100%;
  }
  .el-col {
    height: 100%;
  }
  .fr-box,
  .fl-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .fl-bg {
    height: 100%;
    width: 340px;
    img {
      height: 100%;
    }
  }
  .fr-box-content {
    background: #fff;
    width: 100%;
    padding: 0 35px 20px 35px;
    .login-tit {
      p {
        font-size: 20px;
        color: #3383d0;
        text-align: center;
        line-height: 50px;
        margin: 0;
      }
      i {
        width: 100%;
        height: 20px;
        background: url("../../assets/images/login_lucency.png") no-repeat;
        display: inline-block;
      }
    }
    .login-content {
      .person {
        background: url("../../assets/images/username.png") no-repeat;
        width: 13px;
        height: 13px;
      }
      .password-icon {
        background: url("../../assets/images/password.png") no-repeat;
        width: 13px;
        height: 13px;
      }
      .error {
        font-size: 14px;
        color: red;
      }
      .marginToggle {
        margin-bottom: 0;
      }
    }
    .el-row,
    .el-col {
      height: 40px;
    }
    .verify-img {
      height: 100%;
      margin-right: -20px;
      img {
        height: 100%;
      }
    }
    .rember-pass {
      margin: 20px 0;
      span {
        color: #999999;
        font-size: 14px;
      }
    }
  }
  img {
    display: inline-block;
    height: auto;
    max-width: 100%;
  }
}
</style>
<style lang="scss">
.login {
  .el-input__prefix {
    display: flex;
    align-items: center;
  }
  .el-form-item__error {
    margin-top: 20px;
  }
  .rember-pass {
    span {
      color: #999999;
      font-size: 14px;
    }
  }
  .el-button {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
